<script setup>
import {ref, watch} from 'vue'
import createBicycleInventory from './components/createBicycleInventory/index.vue'

/*表单信息相关*/
// 表单
const ruleForm = ref({

})
// 编辑车辆锚点
const createBicycleInventoryRef = ref()
</script>

<template>
  <createBicycleInventory ref="createBicycleInventoryRef" :isEdit="true" v-model="ruleForm"></createBicycleInventory>
</template>

<style lang="scss" scoped>

</style>
